import {
  ChatroomActionsType,
  SET_CHATROOM_DIALOGUES
} from './actions';
import {
  IChatroomActionHandler, IChatroomDialogue,
  IChatroomInitialState
} from './interfaces';

const ChatroomInitialState: IChatroomInitialState = {
  dialogues: []
};

const setDialogues = ({
  state,
  payload
}: IChatroomActionHandler): IChatroomInitialState => {
  return {
    ...state,
    dialogues: payload as IChatroomDialogue[]
  };
};

const chatroomReducerHandlers = new Map([
  [SET_CHATROOM_DIALOGUES, setDialogues]
]);

const chatroomReducer = (state = ChatroomInitialState, action: ChatroomActionsType): IChatroomInitialState => {
  const handler = chatroomReducerHandlers.get(action.type);

  return (handler && {
    ...handler(<IChatroomActionHandler>{
      state,
      payload: action.payload
    })
  }) || {...state};
};

export default chatroomReducer;
